export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-ivory border-t border-bone/70 px-6 md:px-12 lg:px-20 py-12"
    >
      <div className="mx-auto max-w-[1400px] flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <p className="font-serif text-base md:text-lg tracking-[0.18em] uppercase text-ink">
            A Wider Horizon
          </p>
          <p className="text-xs text-ash mt-2 font-light">
            © {year} Jacob Seal. All rights reserved.
          </p>
        </div>

        <div className="flex flex-col md:items-end gap-2">
          <p className="text-[10px] uppercase tracking-[0.32em] text-ash">
            Created &amp; produced by
          </p>
          <a
            data-testid="footer-creator-link"
            href="https://jacobsealmusic.com"
            target="_blank"
            rel="noopener noreferrer"
            className="font-serif text-xl md:text-2xl font-light text-ink hover:text-gold transition-colors link-underline"
          >
            Jacob Seal · jacobsealmusic.com
          </a>
        </div>
      </div>
    </footer>
  );
}
